<template>
  <v-card variant="flat" class="tw-flex tw-flex-col tw-justify-center tw-items-center">
    <v-card-title class="tw-pb-0">
      <v-img src="@/assets/DAAI_loading.gif" width="100" />
    </v-card-title>
    <v-card-text class="tw-text-primary-500 tw-font-semibold tw-text-center">
      {{ $t('common.loading') }}
    </v-card-text>
  </v-card>
</template>
